// i18n configuration
const i18nConfig = {
  legacy: false,
  locale: 'zh-TW',
  fallbackLocale: 'en',
  messages: {
    'zh-TW': {
      // Navigation
      nav: {
        home: '首頁',
        about: '關於我們',
        projects: '工程案例',
        products: '產品介紹',
        contact: '聯絡我們',
        inquiry: '詢問報價',
        services: '服務項目'
      },
      
      // Hero Section
      hero: {
        title: '逐光而行，構築遮陽的美學秩序',
        subtitle: '以結構的力量與設計的比例，為每一道光與風，找到最穩定的平衡',
        ctaPrimary: '查看工程案例',
        ctaSecondary: '聯絡諮詢'
      },
      
      // About Section
      about: {
        title: '結構，決定安全；比例，決定美感',
        subtitle: '工程 × 美學',
        description: '閎凱綠能遮陽工程成立於嘉義，十餘年專注於遮陽結構與張力設計。我們相信，遮陽不只是防護，更是建築與環境之間的呼吸。從丈量、風壓計算、結構設計到客製布料與施工，每一處都精準對待，讓功能與美感達到最理想的平衡。'
      },
      
      // Services Section
      services: {
        title: '我們提供的不只是安裝，而是一整套結構與設計整合方案',
        items: [
          {
            title: '結構與設計整合',
            description: '依現場條件進行力學分析與比例設計，確保遮陽系統穩定安全'
          },
          {
            title: '客製化張力布料',
            description: '根據使用情境選擇耐候、防水、抗UV等不同規格布料'
          },
          {
            title: '專業施工與驗收',
            description: '經驗團隊精準掌握每一處張力，讓結構與外觀同樣完美'
          }
        ]
      },
      
      // Features Section
      features: {
        title: '專業，從結構開始。美感，在細節完成',
        subtitle: '為什麼選擇閎凱',
        description: '十年工程經驗，轉化為一種精準語言。閎凱以「安全、穩定、比例、美感」為核心原則，從結構思維出發，打造具設計感的遮陽作品。',
        items: [
          '結構計算與風壓模擬',
          '排水導向與安全張力',
          '客製布料整合',
          '專業安裝與維護'
        ]
      },
      
      // Projects Section
      projects: {
        title: '每一個遮陽作品，都是一場結構與光影的對話',
        subtitle: '從住宅庭院到公共空間，我們以工程的精準，完成設計的詩意',
        viewAll: '看更多案例',
        viewDetail: '查看詳情',
        location: '地點',
        area: '面積',
        category: '類型'
      },
      
      // Products Section
      products: {
        title: '遮陽風箏® —— 張力式光影系統',
        subtitle: 'Shade Kite®',
        description: '來自閎凱十年工程經驗的延伸作品。以「張力」為核心，結合模組化結構與光影流動，將遮陽系統轉化為可量產的設計產品。',
        learnMore: '了解 Shade Kite®',
        buyNow: '立即購買',
        specifications: '規格',
        downloadSpec: '下載規格書'
      },
      
      // 
      contact: {
        title: '聯絡我們為你規劃最合適的遮陽方案',
        title2: '0937-438-842',
        description: '立即聯絡，我們將依現場條件與用途，提供專業建議與初步設計。',
        getQuote: '取得報價',
        form: {
          projectDetails: '專案詳細資料',
          personalInfo: '個人資訊',
          consent: '同意聲明',
          firstName: '名字',
          lastName: '姓氏',
          email: '電子郵件',
          phone: '電話號碼',
          message: '訊息 / 專案描述',
          agree: '我同意我的聯絡資訊可能被儲存和處理',
          submit: '送出詢問',
          submitting: '送出中...',
          success: '您的詢問已成功送出，我們會盡快回覆您！',
          error: '送出失敗，請稍後再試或直接聯絡我們'
        },
        company: {
          name: '閎凱綠能科技',
          ceo: '執行長：林佳篁',
          phone: '電話：(05) 2618 021',
          mobile: '手機：0937-438-842',
          email: "'service@hongkai-green.com'",
          address: '嘉義縣竹崎鄉和平村坑仔坪160-3號',
          taxId: '統編：37722021'
        }
      },
      
      // Footer
      footer: {
        company: '閎凱綠能遮陽工程',
        copyright: '版權所有',
        privacy: '隱私政策',
        terms: '使用條款',
        sitemap: '網站地圖',
        backToTop: '全年無休'
      },
      // Home sections (SunSquare style)
      home: {
        create: {
          title: '創造'
        },
        space: {
          title: '空間',
          description: '完美構思。精美執行。',
          cta: '查看模型'
        },
        perfectly: {
          title: '完美構思。精美執行。'
        },
        design: {
          title: '設計與科技的結合',
          description: '宏凱綠能 – 唯一由設計師設計的遮陽帆 – 為精緻戶外空間打造。'
        },
        durable: {
          title: '耐用與優雅',
          description: '所使用的材料保證系統的非凡壽命，並提供長期投資保障。'
        },
        automatic: {
          title: '自動與智慧',
          description: '宏凱綠能系統配備風感應器。在40公里/小時風速時發出信號，並導致系統自動關閉。'
        },
        wherever: {
          title: '無論人們渴望在戶外何處。',
          cta: '探索應用領域'
        },
        quality: {
          title: '對我們來說，品質不是承諾。而是原則。'
        },
        company: {
          title: '專注遮陽結構，打造建築的完美呼吸',
          description: '閎凱綠能十餘年深耕張力設計、風壓計算與客製施工，讓功能與美感精準平衡。',
          cta: '更多關於公司'
        },
        news: {
          title: '最新新聞與活動'
        },
        accessories: {
          title: '閎凱綠能遮陽工程',
          description: '使用原裝閎凱配件，您可以擴展、優化和增強您的遮陽系統。',
          cta: '我們的配件'
        },
        projectCta: {
          title: '您的專案值得最好的遮陽！',
          cta: '請求報價'
        },
        // Application categories
        categories: {
          specials: '特別項目',
          publicSpaces: '公共空間',
          educationCare: '教育與照顧',
          aroundWater: '水邊',
          garden: '花園',
          balcony: '陽台',
          hotelsRestaurants: '飯店與餐廳',
          terrace: '露台',
          rooftopTerrace: '屋頂露台'
        },
        // Quality tabs
        qualityTabs: {
          madeInTaiwan: {
            title: '台灣製造',
            description: '自2010年以來的經驗，規劃到最後細節並在台灣製造。'
          },
          certifiedPatented: {
            title: '認證與專利',
            description: '我們的系統在技術和結構上經過檢查、批准和製造。'
          },
          easyInstallation: {
            title: '輕鬆安裝與維護',
            description: '與全國訓練有素的合作夥伴進行簡單的安裝過程。'
          },
          trainedPartners: {
            title: '全國訓練有素的合作夥伴',
            description: '全國認證合作夥伴網路，提供支援和維護。'
          }
        },
        // Latest news
        latestNews: {
          galaBau: {
            title: 'HOT大聯盟',
            excerpt: '2025年11月10日'
          },
          callweyAward: {
            title: '永世新五金建材有限公司',
            excerpt: '2025年1月22日'
          },
          meesters: {
            title: '信皇車業',
            excerpt: '2024年7月31日'
          }
        }
      },

      // Common
      common: {
        loading: '載入中...',
        error: '發生錯誤',
        retry: '重試',
        cancel: '取消',
        confirm: '確認',
        close: '關閉',
        save: '儲存',
        edit: '編輯',
        delete: '刪除',
        add: '新增',
        view: '查看',
        search: '搜尋',
        filter: '篩選',
        sort: '排序',
        next: '下一個',
        previous: '上一個',
        readMore: '閱讀更多',
        showLess: '顯示較少',
        download: '下載',
        upload: '上傳'
      }
    },
    
    en: {
      // Navigation
      nav: {
        home: 'Home',
        about: 'About',
        projects: 'Projects',
        products: 'Products',
        contact: 'Contact',
        inquiry: 'Inquiry',
        services: 'Services'
      },
      
      // Hero Section
      hero: {
        title: 'Chasing Light, Constructing Aesthetic Order of Shade',
        subtitle: 'With the power of structure and the proportion of design, we find the most stable balance for every ray of light and wind',
        ctaPrimary: 'View Projects',
        ctaSecondary: 'Contact Us'
      },
      
      // About Section
      about: {
        title: 'Structure determines safety; proportion determines aesthetics',
        subtitle: 'Engineering × Aesthetics',
        description: 'Founded in Chiayi, Hong Kai Green Energy Shade Engineering has focused on shade structure and tension design for over a decade. We believe that shade is not just protection, but the breath between architecture and environment. From measurement, wind pressure calculation, structural design to custom fabric and construction, every aspect is precisely treated to achieve the ideal balance between function and aesthetics.'
      },
      
      // Services Section
      services: {
        title: 'We provide not just installation, but a complete structure and design integration solution',
        items: [
          {
            title: 'Structure and Design Integration',
            description: 'Mechanical analysis and proportional design based on site conditions to ensure stable and safe shade systems'
          },
          {
            title: 'Customized Tension Fabrics',
            description: 'Select different specifications of fabrics according to usage scenarios for weather resistance, waterproofing, and UV protection'
          },
          {
            title: 'Professional Construction and Acceptance',
            description: 'Experienced teams precisely master every tension point, making structure and appearance equally perfect'
          }
        ]
      },
      
      // Features Section
      features: {
        title: 'Professionalism starts with structure. Aesthetics is completed in details',
        subtitle: 'Why Hong Kai',
        description: 'Ten years of engineering experience, transformed into a precise language. Hong Kai takes "safety, stability, proportion, aesthetics" as core principles, starting from structural thinking to create designed shade works.',
        items: [
          'Structural calculation and wind pressure simulation',
          'Drainage-oriented and safe tension',
          'Custom fabric integration',
          'Professional installation and maintenance'
        ]
      },
      
      // Projects Section
      projects: {
        title: 'Every shade work is a dialogue between structure and light and shadow',
        subtitle: 'From residential courtyards to public spaces, we achieve the poetry of design with engineering precision',
        viewAll: 'View All Cases',
        viewDetail: 'View Details',
        location: 'Location',
        area: 'Area',
        category: 'Category'
      },
      
      // Products Section
      products: {
        title: 'Shade Kite® - Tension Light and Shadow System',
        subtitle: 'Shade Kite®',
        description: 'An extension work from Hong Kai\'s ten years of engineering experience. With "tension" as the core, combining modular structure with light and shadow flow, transforming shade systems into mass-producible design products.',
        learnMore: 'Learn More About Shade Kite®',
        buyNow: 'Buy Now',
        specifications: 'Specifications',
        downloadSpec: 'Download Specs'
      },
      
      // Contact Section
      contact: {
        title: 'Contact us to plan the most suitable shade solution for you.',
        title2: '0937-438-842',
        description: 'Contact us now. We will provide professional advice and preliminary design based on site conditions and usage.',
        getQuote: 'Get Quote',
        form: {
          projectDetails: 'Key Project Details',
          personalInfo: 'Personal Information',
          consent: 'Consent',
          firstName: 'First Name',
          lastName: 'Last Name',
          email: 'Email Address',
          phone: 'Phone Number',
          message: 'Message / Project Description',
          agree: 'I agree that my contact details may be stored and processed',
          submit: 'Submit Inquiry',
          submitting: 'Submitting...',
          success: 'Your inquiry has been successfully submitted. We will get back to you soon!',
          error: 'Submission failed. Please try again later or contact us directly'
        },
        company: {
          name: 'Hong Kai Green Energy Technology Engineering',
          ceo: 'CEO: Lin Jia-Huang',
          phone: 'Phone: (05) 2618 021',
          mobile: 'Mobile: 0937-438-842',
          email: "'service@hongkai-green.com'",
          address: 'No. 160-3, Kengziping, Heping Village, Zhuqi Township, Chiayi County',
          taxId: 'Tax ID: 37722021'
        }
      },
      
      // Footer
      footer: {
        company: 'Hong Kai Green Energy Shade Engineering',
        copyright: 'All rights reserved',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        sitemap: 'Sitemap',
        backToTop: 'No rest all year round'
      },
      
      // Home sections (SunSquare style)
      home: {
        create: {
          title: 'Create'
        },
        space: {
          title: 'Space',
          description: 'Perfectly conceived. Beautifully executed.',
          cta: 'View models'
        },
        perfectly: {
          title: 'Perfectly conceived. Beautifully executed.'
        },
        design: {
          title: 'Design meets technology',
          description: 'Hong Kai – the only sun sail designed by a designer – created for sophisticated outdoor spaces.'
        },
        durable: {
          title: 'Durable & classy',
          description: 'The materials used guarantee an extraordinary lifespan of the systems and provide long-term investment security.'
        },
        automatic: {
          title: 'Automatic & intelligent',
          description: 'Hong Kai systems are equipped with a wind sensor. This gives a signal at 40 km/h wind speed and causes the automatic closing of the system.'
        },
        wherever: {
          title: 'Wherever people desire to be outdoors.',
          cta: 'Discover fields of application'
        },
        quality: {
          title: 'For us, quality is not a promise. It is a principle.'
        },
        company: {
          title: 'Focus on shade structure, create perfect breath for architecture',
          description: 'Hong Kai Green Energy has been deeply engaged in tension design, wind pressure calculation and custom construction for more than a decade, allowing function and aesthetics to be precisely balanced.',
          cta: 'More about the company'
        },
        news: {
          title: 'Latest news & events'
        },
        accessories: {
          title: 'Hong Kai Green Energy Shade Engineering',
          description: 'With original Hong Kai accessories, you can expand, optimise and enhance your sun sail system.',
          cta: 'Our accessories'
        },
        projectCta: {
          title: 'Your project deserves the best shade!',
          cta: 'Request a quote'
        },
        // Application categories
        categories: {
          specials: 'Specials',
          publicSpaces: 'Public Spaces',
          educationCare: 'Education & Care',
          aroundWater: 'Around Water',
          garden: 'Garden',
          balcony: 'Balcony',
          hotelsRestaurants: 'Hotels & Restaurants',
          terrace: 'Terrace',
          rooftopTerrace: 'Rooftop terrace'
        },
        // Quality tabs
        qualityTabs: {
          madeInTaiwan: {
            title: 'Made in Taiwan',
            description: 'Experience since 2010, planning down to the last detail and manufacturing in Taiwan.'
          },
          certifiedPatented: {
            title: 'Certified & patented',
            description: 'Our systems are technically and structurally inspected, approved and manufactured.'
          },
          easyInstallation: {
            title: 'Easy installation and maintenance',
            description: 'Simple installation process with trained partners nationwide.'
          },
          trainedPartners: {
            title: 'Trained partners nationwide',
            description: 'National network of certified partners for support and maintenance.'
          }
        },
        // Latest news
        latestNews: {
          galaBau: {
            title: 'Gala Bau Nuremberg',
            excerpt: '2026年9月15日至18日'
          },
          callweyAward: {
            title: 'Callwey Award: Gardens of the Year',
            excerpt: '2026年2月26日'
          },
          meesters: {
            title: 'HONG KAI at the Meesters trade fair',
            excerpt: '2025年10月2日至3日，著名的行業活動Meesters in de Tuin將在Cuijk (NL)舉行。'
          }
        }
      },

      // Common
      common: {
        loading: 'Loading...',
        error: 'An error occurred',
        retry: 'Retry',
        cancel: 'Cancel',
        confirm: 'Confirm',
        close: 'Close',
        save: 'Save',
        edit: 'Edit',
        delete: 'Delete',
        add: 'Add',
        view: 'View',
        search: 'Search',
        filter: 'Filter',
        sort: 'Sort',
        next: 'Next',
        previous: 'Previous',
        readMore: 'Read More',
        showLess: 'Show Less',
        download: 'Download',
        upload: 'Upload'
      }
    },
    
    jp: {
      // Navigation
      nav: {
        home: 'ホーム',
        about: '会社概要',
        projects: '施工事例',
        products: '製品紹介',
        contact: 'お問い合わせ',
        inquiry: '見積もり依頼',
        services: 'サービス'
      },
      
      // Hero Section
      hero: {
        title: '光を追いかけ、影の美的秩序を築く',
        subtitle: '構造の力と設計の比例をもって、全ての光と風に最も安定した平衡を見つけ出す',
        ctaPrimary: '施工事例を見る',
        ctaSecondary: 'お問い合わせ'
      },
      
      // About Section
      about: {
        title: '構造が安全を決める、比例が美意識を決める',
        subtitle: 'Engineering × Aesthetics',
        description: '嘉義に設立された鴻凱グリーンエネルギー影工学は、十余年影構造と張力設計に特化しています。影は単なる保護ではなく、建築と環境の間の呼吸だと信じています。計測、風圧計算、構造設計からカスタムファブリック、施工まで、全ての면을精密に扱い、機能と美意識の理想的なバランスを実現しています。'
      },
      
      // Services Section
      services: {
        title: '私たちは単なる設置ではなく、構造と設計の完全な統合ソリューションを提供します',
        items: [
          {
            title: '構造と設計の統合',
            description: '現場条件に基づく力学的分析と比例設計により、影システムの安定性と安全性を確保'
          },
          {
            title: 'カスタム張力ファブリック',
            description: '使用方法に応じて、耐候性、防水性、UV保護などの異なる仕様の布料を選択'
          },
          {
            title: '専門施工と検収',
            description: '経験豊富なチームは全ての張力点を精密に掌握し、構造と外観を同様に完璧に'
          }
        ]
      },
      
      // Features Section
      features: {
        title: '専門性は構造から始まる。美意識は細部で完成する',
        subtitle: 'Why Hong Kai',
        description: '十年的工学経験を精密な言語に変えています。鴻凱は「安全、安定、比例、美意識」を核心原則とし、構造思考から設計された影作品を生み出します。',
        items: [
          '構造計算と風圧シミュレーション',
          '排水指向と安全張力',
          'カスタムファブリック統合',
          '専門設置とメンテナンス'
        ]
      },
      
      // Projects Section
      projects: {
        title: '全ての影作品は、構造と光影の対話',
        subtitle: '住宅庭院から公共空間まで、工学的精度で設計の詩性を実現',
        viewAll: '全事例を見る',
        viewDetail: '詳細を見る',
        location: '場所',
        area: '面積',
        category: 'カテゴリー'
      },
      
      // Products Section
      products: {
        title: 'Shade Kite® - 張力式光影システム',
        subtitle: 'Shade Kite®',
        description: '鴻凱十年的工学経験の延長作品。「張力」を核心とし、モジュール化構造と光影流動を組合せて、影システムを量産可能な設計製品に変換。',
        learnMore: 'Shade Kite®について詳しく',
        buyNow: '今すぐ購入',
        specifications: '仕様',
        downloadSpec: '仕様書ダウンロード'
      },
      
      // Contact Section
      contact: {
        title: 'お客様にとって最も適切な日よけソリューションを計画するために、弊社までお問い合わせください。',
        title2: '0937-438-842',
        description: '今すぐお問い合わせください。現場の状況や用途に合わせた専門的なアドバイスと予備設計をご提供いたします。',
        getQuote: '見積もり取得',
        form: {
          projectDetails: 'プロジェクト詳細',
          personalInfo: '個人情報',
          consent: '同意',
          firstName: '名',
          lastName: '姓',
          email: 'メールアドレス',
          phone: '電話番号',
          message: 'メッセージ / プロジェクト説明',
          agree: '私の連絡先情報が保存・処理されることに同意します',
          submit: '照会を送信',
          submitting: '送信中...',
          success: '您的照會が正常に送信されました。可能な限り早く返信いたします！',
          error: '送信に失敗しました。後でもう一度試すか、直接お問い合わせください'
        },
        company: {
          name: '閎凱綠能科技',
          ceo: 'CEO：林佳篁',
          phone: '電話：(05) 2618 021',
          mobile: '携帯：0937-438-842',
          email: "'service@hongkai-green.com'",
          address: '嘉義県竹崎郷和平村坑子坪160-3号',
          taxId: '統一番号：37722021'
        }
      },
      
      // Footer
      footer: {
        company: '閎凱綠能科技',
        copyright: '全著作権所有',
        privacy: 'プライバシーポリシー',
        terms: '利用規約',
        sitemap: 'サイトマップ',
        backToTop: '一年中休みなし'
      },
      
      // Home sections (SunSquare style)
      home: {
        create: {
          title: '創造'
        },
        space: {
          title: '空間',
          description: '完璧に構想され、美しく実行される。',
          cta: 'モデルを見る'
        },
        perfectly: {
          title: '完璧に構想され、美しく実行される。'
        },
        design: {
          title: 'デザインとテクノロジーの融合',
          description: '宏凱綠能 – デザイナーによって設計された唯一のサンセイル – 洗練された屋外空間のために作成されました。'
        },
        durable: {
          title: '耐久性と優雅さ',
          description: '使用される材料はシステムの非凡な寿命を保証し、長期的な投資セキュリティを提供します。'
        },
        automatic: {
          title: '自動化と知能化',
          description: '宏凱綠能システムは風センサーを装備しています。40km/hの風速で信号を発し、システムの自動閉鎖を引き起こします。'
        },
        wherever: {
          title: '人々が屋外にいたいと思う場所ならどこでも。',
          cta: '用途分野を発見'
        },
        quality: {
          title: '私たちにとって、品質は約束ではありません。それは原則です。'
        },
        company: {
          title: '遮陽構造に焦点を当て、建築の完璧な呼吸を作り出す',
          description: '鴻凱グリーンエネルギーは10年以上にわたり張力設計、風圧計算、カスタム施工に深く従事し、機能と美意識を精密にバランスさせています。',
          cta: '会社についてもっと'
        },
        news: {
          title: '最新ニュースとイベント'
        },
        accessories: {
          title: '鴻凱グリーンエネルギー遮陽工程',
          description: 'オリジナルHong Kaiアクセサリーで、サンセイルシステムを拡張、最適化、強化できます。',
          cta: '私たちのアクセサリー'
        },
        projectCta: {
          title: 'あなたのプロジェクトは最高のシェードに値します！',
          cta: '見積もりをリクエスト'
        },
        // Application categories
        categories: {
          specials: 'スペシャル',
          publicSpaces: '公共スペース',
          educationCare: '教育・ケア',
          aroundWater: '水辺',
          garden: '庭園',
          balcony: 'バルコニー',
          hotelsRestaurants: 'ホテル・レストラン',
          terrace: 'テラス',
          rooftopTerrace: '屋上テラス'
        },
        // Quality tabs
        qualityTabs: {
          madeInTaiwan: {
            title: '台湾製造',
            description: '2010年からの経験、最後の細部まで計画し、台湾で製造。'
          },
          certifiedPatented: {
            title: '認証と特許取得',
            description: '私たちのシステムは技術的および構造的に検査、承認、製造されています。'
          },
          easyInstallation: {
            title: '簡単な設置とメンテナンス',
            description: '全国のトレーニングを受けたパートナーとの簡単な設置プロセス。'
          },
          trainedPartners: {
            title: '全国のトレーニングを受けたパートナー',
            description: 'サポートとメンテナンスのための全国認証パートナーネットワーク。'
          }
        },
        // Latest news
        latestNews: {
          galaBau: {
            title: 'Gala Bau Nuremberg',
            excerpt: '2026年9月15日から18日'
          },
          callweyAward: {
            title: 'Callwey Award: Gardens of the Year',
            excerpt: '2026年2月26日'
          },
          meesters: {
            title: '宏凱綠能 at the Meesters trade fair',
            excerpt: '2025年10月2日から3日、有名な業界イベントMeesters in de TuinがCuijk (NL)で開催されます。'
          }
        }
      },

      // Common
      common: {
        loading: '読み込み中...',
        error: 'エラーが発生しました',
        retry: '再試行',
        cancel: 'キャンセル',
        confirm: '確認',
        close: '閉じる',
        save: '保存',
        edit: '編集',
        delete: '削除',
        add: '追加',
        view: '表示',
        search: '検索',
        filter: 'フィルター',
        sort: 'ソート',
        next: '次へ',
        previous: '前へ',
        readMore: '続きを読む',
        showLess: '表示を少なく',
        download: 'ダウンロード',
        upload: 'アップロード'
      }
    }
  }
}

// Dynamic content loading function
export async function loadDynamicContent(i18n) {
  try {
    const currentLocale = i18n.global.locale.value
    const response = await fetch(`/api/content/${currentLocale}`)

    if (response.ok) {
      const result = await response.json()
      if (result.success && result.data) {
        // Merge dynamic content with existing messages
        Object.keys(result.data).forEach(sectionKey => {
          if (!i18n.global.messages.value[currentLocale][sectionKey]) {
            i18n.global.messages.value[currentLocale][sectionKey] = {}
          }
          Object.assign(i18n.global.messages.value[currentLocale][sectionKey], result.data[sectionKey])
        })
      }
    }
  } catch (error) {
    console.warn('Failed to load dynamic content:', error)
    // Continue with static content if dynamic loading fails
  }
}

export default i18nConfig